import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteCustomFieldParams {
  customFieldId: number;
  categoryId: number;
}

/**
 * カスタムフィールド削除用のフック
 */
export default function useDeleteCustomField() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ customFieldId }: DeleteCustomFieldParams) => {
      const response = await fetch(`/agent/api/custom_fields/${customFieldId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || '削除に失敗しました');
      }

      return response.json();
    },
    onSuccess: (data, variables) => {
      // カテゴリ詳細のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['custom_category', variables.categoryId] });
    },
  });
}
